import { fetch } from '../request';
import type {
  CheckApplyResponse,
  ContactAddRequest,
  ContactEnAddRequest,
  ContactEnData,
  IResponse,
  RequestConfig,
  YanbiApplyRequest,
  YanbiApplyResponse,
} from '../interface';

// 申请言币
export const applyYanbi = (data: YanbiApplyRequest, config?: RequestConfig) => {
  return fetch<IResponse<YanbiApplyResponse>>('/order/apply/', {
    method: 'POST',
    body: data,
    ...config,
  });
};
// 检查申请言币
export const checkApply = (config?: RequestConfig) => {
  return fetch<IResponse<CheckApplyResponse>>('/order/apply/detail/', config);
};

export const addContact = (data: ContactAddRequest, config?: RequestConfig) => {
  return fetch<IResponse>('/user/lead/', {
    method: 'POST',
    body: data,
    ...config,
  });
};

// 海外留资
export const addEnContact = (data: ContactEnAddRequest, config?: RequestConfig) => {
  return fetch<IResponse>('/user/overseas_lead/', {
    method: 'POST',
    body: data,
    ...config,
  });
};

// 获取海外留资枚举值
export const getEnContactInfo = () => {
  return fetch<IResponse<ContactEnData>>('/user/overseas_lead/field_value/', {
    method: 'GET',
  });
};
